import React from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import dayjs from 'dayjs';
import 'dayjs/locale/sv';
import { ColorsV2 } from 'app/constants/color';

dayjs.extend(utc);
dayjs.extend(timezone);

const CustomDatePicker = ({ date, setDate }) => {
  // const today = dayjs();

  const handleDateChange = (newValue) => {
    if (newValue) {
      setDate(newValue.toDate());
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
        disableFuture
        timezone='UTC'
        value={date ? dayjs(date) : null}
        onChange={handleDateChange}
        format="DD MMM YYYY"
        sx={{
            backgroundColor: ColorsV2.primary,
            color: ColorsV2.white,
            borderRadius: "4px",
            width: 'fit-content',

            "& .MuiInputBase-root": {
            height: "40px",
            width: "275px",
            border: "solid 2px transparent",
            transition: "border-color 0.3s ease-in-out",
            borderRadius: "4px",
            },

            "& .MuiInputBase-input": {
            color: ColorsV2.white,
            },

            "&:hover .MuiInputBase-root": {
            borderColor: ColorsV2.acent,
            },

            "& .MuiInputBase-root.Mui-focused": {
            borderColor: "transparent",
            boxShadow: "none",
            },

            "& .MuiOutlinedInput-notchedOutline": {
            border: "none",
            },

            "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
            border: "none",
            },

            "& .MuiOutlinedInput-root.Mui-focused": {
            border: "2px solid " + ColorsV2.acent,
            },
        }}
        slotProps={{
            textField: {
            sx: {
                backgroundColor: ColorsV2.primary,
                color: ColorsV2.white,
                borderRadius: "4px",
                width: 'fit-content',

                "& .MuiInputBase-root": {
                height: "40px",
                width: "275px",
                border: "solid 2px transparent",
                transition: "border-color 0.3s ease-in-out",
                borderRadius: "4px",
                },

                "& .MuiInputBase-input": {
                color: ColorsV2.white,
                },

                "&:hover .MuiInputBase-root": {
                borderColor: ColorsV2.acent,
                },

                "& .MuiInputBase-root.Mui-focused": {
                borderColor: "transparent",
                boxShadow: "none",
                },

                "& .MuiOutlinedInput-notchedOutline": {
                border: "none",
                },

                "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                border: "none",
                },

                "& .MuiOutlinedInput-root.Mui-focused": {
                border: "2px solid " + ColorsV2.acent,
                },

                "& .MuiSvgIcon-root": {
                color: ColorsV2.white,
                transition: "color 0.3s ease-in-out",
                },
                "&:hover .MuiSvgIcon-root": {
                // color: ColorsV2.acent, 
                },
            },
            },
            desktopPaper: {
            sx: {
                backgroundColor: ColorsV2.primary,
                color: ColorsV2.white,

                "& .MuiPickersDay-root": {
                "&:hover": {
                    color: ColorsV2.acent,
                },
                },

                "& .MuiPickersDay-root.Mui-selected": {
                backgroundColor: ColorsV2.acent,
                color: ColorsV2.white,
                "&:hover": {
                    color: ColorsV2.white,
                    backgroundColor: ColorsV2.acent,
                },
                },

                "& .MuiSvgIcon-root": {
                    color: ColorsV2.white,
                },
            },
            },
        }}
        />
    </LocalizationProvider>
  );
};

export default CustomDatePicker;
